<template>
  <el-container class="finance_info">
    <el-header class="header-style">
      <el-divider content-position="left">记账报税</el-divider>
      <el-row>
        <el-col :span="1">
          <el-popover placement="bottom-start" v-model="questionVisible" width="320">
            <el-row style="padding-left: 20px">
              <el-col style="color: #409eff; margin: 0.2rem 0 0.5rem 0">
                <el-col>图标颜色为灰色，表示当前未完成或没有</el-col>
                <el-col>颜色为绿色，表示当前已完成或进行中</el-col>
              </el-col>
              <el-col class="m-label-top">
                <el-col :span="4"
                  ><el-button size="mini" icon="el-icon-message-solid" circle></el-button
                ></el-col>
                <el-col :span="20">表示提醒客户开始记账报税</el-col>
              </el-col>
              <el-col class="m-label-top">
                <el-col :span="4"
                  ><el-button size="mini" icon="el-icon-upload" circle></el-button
                ></el-col>
                <el-col :span="20">表示上传预申报记账报税截图信息</el-col>
              </el-col>
              <el-col class="m-label-top">
                <el-col :span="4"
                  ><el-button size="mini" icon="el-icon-message" circle></el-button
                ></el-col>
                <el-col :span="20">表示客户是否有资料发送至我方</el-col>
              </el-col>
              <el-col class="m-label-top">
                <el-col :span="4"
                  ><el-button size="mini" icon="el-icon-s-claim" circle></el-button
                ></el-col>
                <el-col :span="20">表示客户是否确认预申报信息</el-col>
              </el-col>
              <el-col class="m-label-top">
                <el-col :span="4"
                  ><el-button size="mini" icon="el-icon-finished" circle></el-button
                ></el-col>
                <el-col :span="20">表示上传申报成功后的截图</el-col>
              </el-col>
              <el-col class="m-label-top">
                <el-col :span="4"
                  ><el-button size="mini" icon="el-icon-s-order" circle></el-button
                ></el-col>
                <el-col :span="20">表示纳税明细的录入情况</el-col>
              </el-col>
            </el-row>
            <el-button
              slot="reference"
              class="el-icon-question"
              style="font-size: 18px; border: none; color: #409eff"
              size="mini"
            ></el-button>
          </el-popover>
        </el-col>
        <el-col :span="4" style="margin-right: 5px">
          <el-select
            v-model="searchArr.company_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入公司字号筛选公司"
            size="mini"
            clearable
            @change="handleCompanyChange"
            :remote-method="remoteCompanyMethod"
            :loading="loading"
          >
            <el-option
              v-for="company in companies"
              :key="company.id"
              :label="company.company_name"
              :value="company.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="margin-right: 5px">
          <el-date-picker
            v-model="searchArr.dateTime"
            type="month"
            size="mini"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            :picker-options="pickerOptions"
            @change="handleCompanyChange"
            placeholder="选择月份"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4" style="margin-right: 5px">
          <el-select
            collapse-tags
            v-model="searchArr.is_confirm"
            placeholder="请选择通知状态"
            @change="handleCompanyChange"
            size="mini"
            clearable
          >
            <el-option :value="6" label="未开始服务"></el-option>
            <el-option :value="7" label="通知记账材料"></el-option>
            <el-option :value="8" label="无材料0申报"></el-option>
            <el-option :value="1" label="有材料未开始记账"></el-option>
            <el-option :value="2" label="报税确认截图"></el-option>
            <el-option :value="3" label="客户确认报税截图"></el-option>
            <el-option :value="4" label="客户调整报税"></el-option>
            <el-option :value="5" label="报税完成"></el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="margin-right: 5px">
          <el-popover placement="bottom-start" v-model="searchVisible" width="320">
            <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
              <el-col :span="6" style="margin-top: 0.1rem">理票会计：</el-col>
              <el-col :span="18">
                <el-cascader
                  v-model="searchArr.acc_id"
                  placeholder="请选择理票会计"
                  :options="allusersAddition"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">记账报税会计：</el-col>
              <el-col :span="18">
                <el-cascader
                  v-model="searchArr.advisory_id"
                  placeholder="请选择记账报税会计"
                  :options="allusersAddition"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">客服会计：</el-col>
              <el-col :span="18">
                <el-cascader
                  v-model="searchArr.ass_id"
                  placeholder="请选择客服会计"
                  :options="allusersAddition"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">开票会计：</el-col>
              <el-col :span="18">
                <el-cascader
                  v-model="searchArr.invoice_id"
                  placeholder="请选择开票会计"
                  :options="allusersAddition"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">财税负责人：</el-col>
              <el-col :span="18">
                <el-cascader
                  v-model="searchArr.leader_id"
                  placeholder="请选择财税负责人"
                  :options="allusersAddition"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">所属业务：</el-col>
              <el-col :span="18">
                <el-cascader
                  v-model="searchArr.saler_id"
                  placeholder="请选择所属业务"
                  :options="allusersAddition"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">是否绑定：</el-col>
              <el-col :span="18">
                <el-radio-group v-model="searchArr.is_bind" size="mini">
                  <el-radio label="1" border>未绑定</el-radio>
                  <el-radio label="2" border>已绑定</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">是否关注：</el-col>
              <el-col :span="18">
                <el-radio-group v-model="searchArr.is_subscribe" size="mini">
                  <el-radio label="1" border>未关注</el-radio>
                  <el-radio label="2" border>已关注</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">有无快递：</el-col>
              <el-col :span="18">
                <el-radio-group v-model="searchArr.is_express" size="mini">
                  <el-radio label="1" border>无快递</el-radio>
                  <el-radio label="2" border>有快递</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">有无文件：</el-col>
              <el-col :span="18">
                <el-radio-group v-model="searchArr.is_files" size="mini">
                  <el-radio label="1" border>无文件</el-radio>
                  <el-radio label="2" border>有文件</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">有无档案：</el-col>
              <el-col :span="18">
                <el-radio-group v-model="searchArr.archives" size="mini">
                  <el-radio label="1" border>有档案</el-radio>
                  <el-radio label="2" border>无档案</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="12" :offset="12">
                <el-button size="mini" @click="handleClearSearchGetData">清除</el-button>
                <el-button type="primary" @click="handleSearchGetData" size="mini"
                  >查询</el-button
                >
              </el-col>
            </el-row>
            <el-button slot="reference" size="mini">筛选</el-button>
          </el-popover>
        </el-col>
        <el-col :span="2">
          <el-tooltip content="每次最多通知100家客户" placement="top">
            <el-button
              style="margin-left: 20%"
              type="primary"
              size="mini"
              @click="batchInform()"
              >批量通知</el-button
            >
          </el-tooltip>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-tooltip content="是否开启公众号通知" placement="top">
            <el-radio-group
              v-model="is_send"
              size="mini"
              @change="handleChangeIsSendWxMsg"
            >
              <el-radio-button label="1">开启</el-radio-button>
              <el-radio-button label="2">关闭</el-radio-button>
            </el-radio-group>
          </el-tooltip>
        </el-col>
        <!-- <el-col :span="1">
        <el-tooltip effect="dark" content="导入公司服务人员" placement="top" >
          <el-popover placement="left-start" width="500" trigger="click">
            <el-form :model="addAddressForm" :rules="addressRules" ref="addAddressForm" label-width="110px">
              <el-form-item label="公司名称位置" prop="addressee">
                <el-select v-model="addAddressForm.addressee" placeholder="请选择" style="width: 100%" clearable
                  filterable size="mini">
                  <el-option v-for="item in 20" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分组位置" prop="group">
                <el-select v-model="addAddressForm.group" placeholder="请选择" style="width: 100%" clearable
                  filterable size="mini">
                  <el-option v-for="item in 20" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <upfile acc="" :acce="[]"  name="上传excel" :many="1" action="api/ysy_common_import_servicer" :mul="false" :up_path="{company:addAddressForm.addressee,group:addAddressForm.group}" bus="ysy_import_servicer"/>
            <div style="
                      margin-top: 0.15rem;
                      text-align: right;
                    ">
            </div>
              <el-button slot="reference" size="mini" type="warning">导入</el-button>
          </el-popover>
        </el-tooltip>
      </el-col> -->
      </el-row>
      <el-row style="margin: 0.2rem 0">
        <el-col> 日期：{{ list_month }} </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table
        height="calc(100vh - 276px)"
        :data="pageData"
        :show-overflow-tooltip="true"
        style="width: 100%"
        border
      >
        <el-table-column label="公司名称" width="240" fixed>
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.company_name" placement="top">
              <div class="company_hover">
                <span class="count_style" style="display: inherit">
                  <el-link
                    type="primary"
                    @click="
                      handleOpen(scope.row.id, scope.row.company_name, scope.$index)
                    "
                  >
                    <i
                      v-if="
                        ['2021-01', '2021-04', '2021-07', '2021-10'].indexOf(
                          scope.row.state
                            ? scope.row.state.month
                            : searchArr.dateTime
                            ? searchArr.dateTime
                            : list_month
                        ) !== -1
                      "
                      class="el-icon-s-order"
                      style="color: red"
                    ></i>
                    {{ scope.row.company_name }}
                  </el-link>
                  <el-row>
                    <el-button
                      v-if="!scope.row.inform"
                      type="info"
                      size="mini"
                      icon="el-icon-message-solid"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-else
                      type="success"
                      size="mini"
                      icon="el-icon-message-solid"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-if="!scope.row.upload"
                      type="info"
                      size="mini"
                      icon="el-icon-upload"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-else
                      type="success"
                      size="mini"
                      icon="el-icon-upload"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-if="!scope.row.feedback.length"
                      type="info"
                      size="mini"
                      icon="el-icon-message"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-else
                      type="success"
                      size="mini"
                      icon="el-icon-message"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-if="scope.row.affirm || scope.row.success"
                      type="success"
                      size="mini"
                      icon="el-icon-s-claim"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-else
                      type="info"
                      size="mini"
                      icon="el-icon-s-claim"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-if="!scope.row.success"
                      type="info"
                      size="mini"
                      icon="el-icon-finished"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-else
                      type="success"
                      size="mini"
                      icon="el-icon-finished"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-if="!scope.row.tax_total"
                      type="info"
                      size="mini"
                      icon="el-icon-s-order"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-button
                      v-else
                      type="success"
                      size="mini"
                      icon="el-icon-s-order"
                      style="padding: 2px"
                      circle
                    ></el-button>
                    <el-tooltip class="item" effect="dark" content="复制" placement="top"
                      ><i
                        class="el-icon-document-copy"
                        style="
                          margin-left: 0.1rem;
                          cursor: pointer;
                          vertical-align: middle;
                        "
                        @click="copySome(scope.row.company_name)"
                      ></i
                    ></el-tooltip>
                  </el-row>
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="state.month" label="月份" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.state ? scope.row.state.month : list_month" placement="top">
            <span class="hide-style">{{ scope.row.state ? scope.row.state.month : searchArr.dateTime ? searchArr.dateTime
              : list_month }}</span>
          </el-tooltip>
        </template>
      </el-table-column> -->
        <el-table-column prop="state.is_confirm" label="报税进度" fixed>
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.state ? scope.row.state.is_confirm : '未开始服务'"
              placement="top"
            >
              <span class="hide-style">{{
                scope.row.state ? scope.row.state.is_confirm : "未开始服务"
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="user.name" label="用户名称" width="120">
          <template slot-scope="scope">
            <!-- <el-tooltip :content="scope.row.user ?  scope.row.user.name : ''" placement="top"> -->
            <el-link
              type="primary"
              :underline="false"
              style="padding: 0; border: none"
              slot="reference"
              @click="handleShowPayerContent(scope.row)"
              >{{ scope.row.user ? scope.row.user.name : "" }}</el-link
            >
            <!-- <span class="hide-style">{{ scope.row.user ? scope.row.user.name : '' }}</span> -->
            <!-- </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column prop="oauth.subscribe" label="是否关注公众号" width="120">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.oauth
                  ? scope.row.oauth.subscribe === 1
                    ? '已关注'
                    : '未关注'
                  : '未关注'
              "
              placement="top"
            >
              <span class="hide-style">{{
                scope.row.oauth
                  ? scope.row.oauth.subscribe === 1
                    ? "已关注"
                    : "未关注"
                  : "未关注"
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="state.is_confirm" label="代账软件">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.com_fiscal_tax
                  ? scope.row.com_fiscal_tax.software_types === 1
                    ? '17DZ'
                    : scope.row.com_fiscal_tax.software_types == 2
                    ? '云账房'
                    : scope.row.com_fiscal_tax.software_types === 3
                    ? '易代账'
                    : '其他'
                  : '未知'
              "
              placement="top"
            >
              <span class="hide-style">{{
                scope.row.com_fiscal_tax
                  ? scope.row.com_fiscal_tax.software_types === 1
                    ? "17DZ"
                    : scope.row.com_fiscal_tax.software_types == 2
                    ? "云账房"
                    : scope.row.com_fiscal_tax.software_types === 3
                    ? "易代账"
                    : "其他"
                  : "未知"
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="state.month" label="报税通知/通知人员" width="250px">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-tooltip content="通知客户" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-bell"
                  :disabled="getDisabledStatus(scope.row)"
                  @click="handleInform(scope.row, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-avatar
                v-if="scope.row.inform"
                style="
                  margin-right: 0.2rem;
                  width: 28px;
                  height: 28px;
                  margin-left: 0.2rem;
                "
                :src="scope.row.inform ? imgPath + scope.row.inform.admin.buphoto : ''"
              >
              </el-avatar>
              <el-tooltip
                :content="
                  scope.row.inform
                    ? scope.row.inform.admin.username + ' ' + scope.row.inform.created_at
                    : ''
                "
                placement="top"
              >
                <div
                  style="color: #409eff; cursor: pointer"
                  @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                >
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.inform ? scope.row.inform.admin.username : "" }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.inform ? scope.row.inform.created_at : "" }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="state.is_confirm" label="反馈人员" width="120">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.feedback.length
                  ? (scope.row.feedback[0].wx_user
                      ? scope.row.feedback[0].wx_user.username
                      : '') +
                    ' ' +
                    scope.row.feedback[0].created_at
                  : ''
              "
              placement="top"
            >
              <div
                style="color: #409eff; cursor: pointer"
                @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
              >
                <span class="hide-style" style="font-size: 0.1rem">
                  {{
                    scope.row.feedback.length
                      ? scope.row.feedback[0].wx_user
                        ? scope.row.feedback[0].wx_user.username
                        : ""
                      : ""
                  }}
                </span>
                <span class="hide-style" style="font-size: 0.1rem">
                  {{ scope.row.feedback.length ? scope.row.feedback[0].created_at : "" }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="申报截图/申报上传人员" width="260">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-tooltip content="上传图片" placement="top" v-if="!scope.row.upload">
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-upload2"
                  @click="handleUploadImg(scope.row, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="修改图片"
                placement="top"
                v-if="scope.row.upload && !scope.row.success"
              >
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  @click="handleEditImg(scope.row, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip content="查看图片" placement="top" v-if="scope.row.upload">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-picture-outline"
                  @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-avatar
                v-if="scope.row.revamp.length ? true : scope.row.upload"
                style="
                  margin-right: 0.2rem;
                  width: 28px;
                  height: 28px;
                  margin-left: 0.2rem;
                "
                :src="
                  scope.row.revamp.length
                    ? imgPath + scope.row.revamp[0].admin.buphoto
                    : scope.row.upload
                    ? imgPath + scope.row.upload.admin.buphoto
                    : ''
                "
              >
              </el-avatar>
              <el-tooltip
                :content="
                  scope.row.revamp.length
                    ? scope.row.revamp[0].admin.username +
                      ' ' +
                      scope.row.revamp[0].created_at
                    : scope.row.upload
                    ? scope.row.upload.admin.username + ' ' + scope.row.upload.created_at
                    : ''
                "
                placement="top"
              >
                <div>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.revamp.length
                        ? scope.row.revamp[0].admin.username
                        : scope.row.upload
                        ? scope.row.upload.admin.username
                        : ""
                    }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.revamp.length
                        ? scope.row.revamp[0].created_at
                        : scope.row.upload
                        ? scope.row.upload.created_at
                        : ""
                    }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="state.month"
          v-if="false"
          label="申报上传人员"
          style="margin: 0; padding: "
        >
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.revamp.length
                  ? scope.row.revamp[0].admin.username +
                    ' ' +
                    scope.row.revamp[0].created_at
                  : scope.row.upload
                  ? scope.row.upload.admin.username + ' ' + scope.row.upload.created_at
                  : ''
              "
              placement="top"
            >
              <div>
                <span class="hide-style" style="font-size: 0.1rem">
                  {{
                    scope.row.revamp.length
                      ? scope.row.revamp[0].admin.username
                      : scope.row.upload
                      ? scope.row.upload.admin.username
                      : ""
                  }}
                </span>
                <span class="hide-style" style="font-size: 0.1rem">
                  {{
                    scope.row.revamp.length
                      ? scope.row.revamp[0].created_at
                      : scope.row.upload
                      ? scope.row.upload.created_at
                      : ""
                  }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="客户反馈">
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.state ? scope.row.state.remark : ''"
              placement="top"
            >
              <span class="hide-style">{{
                scope.row.state ? scope.row.state.remark : ""
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="确认时间">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.affirm
                  ? scope.row.affirm.wx_user.username + ' ' + scope.row.affirm.created_at
                  : ''
              "
              placement="top"
            >
              <div>
                <span class="hide-style" style="font-size: 0.1rem">
                  {{ scope.row.affirm ? scope.row.affirm.wx_user.username : "" }}
                </span>
                <span class="hide-style" style="font-size: 0.1rem">
                  {{ scope.row.affirm ? scope.row.affirm.created_at : "" }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="申报成功/完成上传人员" width="260">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-tooltip content="查看图片" placement="top" v-if="scope.row.success">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-picture-outline"
                  @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip content="上传图片" placement="top" v-else>
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-upload2"
                  @click="handleUploadImgSuccess(scope.row, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip content="上传图片" placement="top" v-if="scope.row.success">
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-upload2"
                  @click="handleUploadImgSuccess(scope.row, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-avatar
                v-if="scope.row.success"
                style="
                  margin-right: 0.2rem;
                  width: 28px;
                  height: 28px;
                  margin-left: 0.2rem;
                "
                :src="scope.row.success ? imgPath + scope.row.success.admin.buphoto : ''"
              >
              </el-avatar>
              <el-tooltip
                :content="
                  scope.row.success
                    ? scope.row.success.admin.username +
                      ' ' +
                      scope.row.success.created_at
                    : ''
                "
                placement="top"
              >
                <div>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.success ? scope.row.success.admin.username : "" + "\n" }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.success ? scope.row.success.created_at : "" }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="聊天记录" width="240">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="聊天记录" placement="top">
              <el-button
                type="primary"
                :disabled="scope.row.chat_com ? false : true"
                size="mini"
                icon="el-icon-s-comment"
                @click="handleChatOpen(scope.row.chat_com, scope.row.company_name)"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="企业微信群聊天记录"
              placement="top"
            >
              <el-button
                type="warning"
                :disabled="scope.row.wx_work_chat_com ? false : true"
                @click="
                  handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
                "
                size="mini"
                icon="el-icon-s-comment"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="企友聊天记录" placement="top">
              <el-button
                type="success"
                :disabled="scope.row.qy_chat_com ? false : true"
                size="mini"
                icon="el-icon-s-comment"
                @click="handleQyChatOpen(scope.row.qy_chat_com, scope.row.company_name)"
                circle
              ></el-button>
            </el-tooltip>
            <span v-if="scope.row.tax_payment">
              <el-tooltip
                class="item"
                effect="dark"
                content="录入纳税明细"
                placement="top"
              >
                <el-button
                  size="mini"
                  icon="el-icon-s-order"
                  circle
                  @click="handleTaxDetail(scope.row, scope.$index)"
                ></el-button>
              </el-tooltip>
            </span>
            <span v-else>
              <el-tooltip
                class="item"
                effect="dark"
                content="录入纳税明细"
                placement="top"
              >
                <el-button
                  size="mini"
                  icon="el-icon-s-order"
                  @click="handleAlertAddFinance"
                  circle
                ></el-button>
              </el-tooltip>
            </span>
            <span>
              <el-tooltip class="item" effect="dark" content="财税建议" placement="top">
                <el-button
                  size="mini"
                  icon="el-icon-reading"
                  @click="handleTaxAdvice(scope.row, scope.$index)"
                  circle
                  type="primary"
                ></el-button>
              </el-tooltip>
            </span>

            <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-phone-outline"
                circle
                @click="handCallLogsOpen(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer-style">
      <el-pagination
        background
        class="mt-10"
        layout="total, sizes, prev, pager, next, jumper"
        :hide-on-single-page="true"
        :current-page="pageOption.currentPage"
        :page-sizes="pageOption.pageSizes"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      :title="'上传图片【' + companyName + '】'"
      :visible.sync="uploadingDrawer"
      :before-close="handleAddClose"
      size="40%"
    >
      <div class="drawer-content">
        <el-form
          :model="addForm"
          :rules="addRules"
          ref="addForm"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="月份" prop="month">
            <el-date-picker
              v-model="addForm.declare_month"
              type="month"
              size="mini"
              readonly
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              @change="pickerDataChangeUpload"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="user_remark">
            <el-input
              v-model="addForm.user_remark"
              type="textarea"
              placeholder="请输入需要告知客户的信息(若无 可不填写)"
            />
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-card shadow="hover">
              <el-upload
                multiple
                ref="upload"
                action="#"
                accept="image/png, image/jpeg, image/gif"
                :limit="5"
                :on-preview="handleLicensePreview"
                :on-change="handleLicenseChange"
                :on-remove="handleLicenseRemove"
                :file-list="licenseList"
                list-type="picture"
                :auto-upload="false"
              >
                <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
              </el-upload>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="mt-10">
          <el-input
            v-paste="handleParse"
            type="textarea"
            placeholder="请点击此处，再粘贴复制的截图"
          />
        </el-row>
        <el-row class="mt-10">
          <el-col :span="24" class="text-r">
            <el-button type="primary" size="mini" @click="submitAddUpload('addForm')"
              >添加</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="财税建议"
      :visible.sync="categoryIndrawer"
      direction="rtl"
      :before-close="handleCloseIn"
      size="50%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -10px">
        <tax-advice :comId="adviceComId" :comName="adviceComName"></tax-advice>
      </div>
    </el-drawer>
    <el-drawer
      :title="'修改图片【' + companyName + '】'"
      :visible.sync="uploadingSaveDrawer"
      :before-close="handleSaveClose"
      size="40%"
    >
      <div class="drawer-content">
        <el-form
          :model="saveForm"
          :rules="saveRules"
          ref="saveForm"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="月份" prop="month">
            <el-date-picker
              v-model="saveForm.declare_month"
              type="month"
              size="mini"
              readonly
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              @change="pickerDataChangeRevamp"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="user_remark">
            <el-input
              v-model="saveForm.user_remark"
              type="textarea"
              placeholder="请输入需要告知客户的信息(若无 可不填写)"
            />
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-card shadow="hover">
              <el-upload
                multiple
                ref="upload"
                action="#"
                accept="image/png, image/jpeg, image/gif"
                :limit="5"
                :on-preview="handleLicenseSavePreview"
                :on-change="handleLicenseSaveChange"
                :on-remove="handleLicenseSaveRemove"
                :file-list="licenseSaveList"
                list-type="picture"
                :auto-upload="false"
              >
                <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
              </el-upload>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="mt-10">
          <el-input
            v-paste="handleUpdateParse"
            type="textarea"
            placeholder="请点击此处，再粘贴复制的截图"
          />
        </el-row>
        <el-row class="mt-10">
          <el-col :span="24" class="text-r">
            <el-button type="primary" size="mini" @click="submitSaveUpload('saveForm')"
              >添加</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <!--    申报完成上传图片-->
    <el-drawer
      :title="'申报成功上传图片【' + companyName + '】'"
      :visible.sync="uploadingSuccessDrawer"
      :before-close="handleAddSuccessClose"
      size="40%"
    >
      <div class="drawer-content">
        <el-form
          :model="addSuccessForm"
          :rules="addSuccessRules"
          ref="addSuccessForm"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="月份" prop="month">
            <el-date-picker
              v-model="addSuccessForm.declare_month"
              type="month"
              size="mini"
              readonly
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              @change="pickerDataChangeSuccess"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="user_remark">
            <el-input
              v-model="addSuccessForm.user_remark"
              type="textarea"
              placeholder="请输入需要告知客户的信息(若无 可不填写)"
            />
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-card shadow="hover">
              <el-upload
                ref="upload"
                action="#"
                accept="image/png, image/jpeg, image/gif"
                :limit="1"
                :on-preview="handleLicenseSuccessPreview"
                :on-change="handleLicenseSuccessChange"
                :on-remove="handleLicenseSuccessRemove"
                :file-list="licenseSuccessList"
                list-type="picture"
                :auto-upload="false"
              >
                <el-link slot="trigger" type="primary">上传截图</el-link>
              </el-upload>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="mt-10">
          <el-input
            v-paste="handleSuccessParse"
            type="textarea"
            placeholder="请点击此处，再粘贴复制的截图"
          />
        </el-row>
        <el-row class="mt-10">
          <el-col :span="24" class="text-r">
            <el-button
              type="primary"
              size="mini"
              @click="submitAddSuccessUpload('addSuccessForm')"
              >添加</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog title="批量通知" :visible.sync="batchDialog" width="30%">
      <el-date-picker
        v-model="dateTime"
        type="month"
        size="mini"
        format="yyyy 年 MM 月"
        value-format="yyyy-MM"
        :picker-options="pickerOptions"
        placeholder="选择月份"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="batchDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="batchSendInform">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      :title="'服务记录【' + companyName + '】'"
      :visible.sync="backCluesDrawer"
      direction="rtl"
      :before-close="handleAddDrawerBeforeClose"
      size="60%"
      fullscreen
    >
      <div style="margin-left: 0.4rem">
        <div class="m-tabs-content">
          <div class="blocka">
            <el-tabs v-model="showTabPane" type="border-card">
              <el-tab-pane label="服务记录" name="first">
                <el-collapse
                  v-model="activeName"
                  v-for="(all_records, index) in OperationRecord"
                  :key="index"
                  accordion
                  style="border-bottom: 1px solid #ebeef5"
                >
                  <el-collapse-item
                    :title="all_records.month + ' 财税服务详情'"
                    :name="index + 1"
                  >
                    <el-timeline>
                      <el-timeline-item
                        v-for="(item, index) in all_records.records"
                        :key="index"
                        :timestamp="item.created_at"
                        placement="top"
                      >
                        <el-card v-if="item.declare_type === '反馈记账资料'">
                          <p style="margin-bottom: 0.2rem">
                            {{
                              item.wx_user
                                ? item.wx_user.username + " " + item.declare_type
                                : item.admin.username + " " + item.declare_type
                            }}
                          </p>
                          <span v-if="item.express">
                            <el-collapse>
                              <el-row style="margin-bottom: 0">
                                <el-col :span="6">快递状态：</el-col>
                                <el-col
                                  :span="5"
                                  style="color: #4c87fc; font-weight: bold"
                                  >{{
                                    item.express.accept_status
                                      ? item.express.accept_status
                                      : "暂无状态"
                                  }}</el-col
                                >
                                <el-col :span="11" :offset="2">
                                  <el-tooltip content="点击复制快递单号" placement="top">
                                    <span
                                      class="count_style"
                                      style="
                                        display: inherit;
                                        color: orange;
                                        cursor: pointer;
                                      "
                                      @click="copyStr(item.express.exp_num)"
                                      >{{
                                        item.express ? item.express.exp_num : ""
                                      }}</span
                                    >
                                  </el-tooltip>
                                </el-col>
                              </el-row>
                              <el-collapse-item title="快递信息（点此展开）">
                                <div class="block">
                                  <el-timeline>
                                    <el-timeline-item
                                      v-for="(item, index) in item.express.content"
                                      :key="index"
                                      :timestamp="item.time"
                                    >
                                      {{ item.status }}
                                    </el-timeline-item>
                                  </el-timeline>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                          </span>
                          <span v-if="item.image_url">
                            <span v-for="(imgUrl, index) in item.image_url" :key="index">
                              <el-image
                                class="image"
                                :src="imgUrl"
                                :preview-src-list="item.image_url"
                                v-if="item.image_url"
                                style="margin-right: 0.1rem"
                              ></el-image>
                            </span>
                          </span>
                          <span v-if="item.file_url">
                            <div>
                              <el-button
                                class="btns"
                                size="mini"
                                type="success"
                                @click="
                                  downloadFile('/storage/fin_info/' + item.file_url)
                                "
                                >下载文件</el-button
                              >
                            </div>
                          </span>
                          <span v-if="!item.file_url && !item.express && !item.image_url"
                            >无文件资料</span
                          >
                        </el-card>
                        <el-card v-else>
                          <p style="margin-bottom: 0.2rem">
                            {{
                              item.wx_user
                                ? item.wx_user.username + " " + item.declare_type
                                : item.admin.username + " " + item.declare_type
                            }}
                          </p>
                          <span v-for="(imgUrl, index) in item.image_url" :key="index">
                            <el-image
                              class="image"
                              :src="imgUrl"
                              :preview-src-list="item.image_url"
                              v-if="item.image_url"
                              style="margin-right: 0.1rem"
                            ></el-image>
                          </span>
                          <p
                            v-if="!item.image_url || item.declare_type === '报税成功'"
                            style="font-size: 0.24rem; line-height: 0.6rem"
                          >
                            备注：{{ item.user_remark ? item.user_remark : "无" }}
                          </p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="公司信息" name="second">
                <el-divider content-position="left"
                  ><span class="top-line">基础信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="公司名称" placement="top">
                      <span class="count_style" style="display: inherit">公司名称：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip content="点击复制" placement="top">
                      <span
                        class="count_style copy-col"
                        @click="copySignMsg(com_msgs.company_name)"
                        >{{ com_msgs.company_name }}</span
                      >
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="服务时间" placement="top">
                      <span class="count_style" style="display: inherit">服务时间：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip content="点击复制" placement="top">
                      <span
                        class="count_style copy-col"
                        @click="
                          copySignMsg(
                            com_msgs.fin_reg
                              ? (com_msgs.fin_reg.start_time
                                  ? com_msgs.fin_reg.start_time
                                  : '') +
                                  ' 至 ' +
                                  (com_msgs.fin_reg.end_time
                                    ? com_msgs.fin_reg.end_time
                                    : '')
                              : ''
                          )
                        "
                      >
                        {{
                          com_msgs.fin_reg
                            ? (com_msgs.fin_reg.start_time
                                ? com_msgs.fin_reg.start_time
                                : "") +
                              " 至 " +
                              (com_msgs.fin_reg.end_time ? com_msgs.fin_reg.end_time : "")
                            : ""
                        }}
                      </span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-col :span="8" class="m-label">
                      <el-tooltip content="公司税号" placement="top">
                        <span class="count_style" style="display: inherit"
                          >公司税号：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style copy-col"
                          @click="copySignMsg(com_msgs.taxNumber)"
                          >{{ com_msgs.taxNumber }}</span
                        >
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="8" class="m-label">
                      <el-tooltip content="法人电话" placement="top">
                        <span class="count_style" style="display: inherit"
                          >法人电话：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style copy-col"
                          @click="copySignMsg(com_msgs.legaler_contact)"
                          >{{ com_msgs.legaler_contact }}</span
                        >
                      </el-tooltip>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="单位地址" placement="top">
                      <span class="count_style" style="display: inherit">单位地址：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="18" class="m-label">
                    <el-tooltip content="点击复制" placement="top">
                      <span
                        class="count_style copy-col"
                        @click="copySignMsg(com_msgs.operate_address)"
                        >{{ com_msgs.operate_address }}</span
                      >
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">服务信息</span></el-divider
                >
                <el-row>
                  <el-col class="m-label" :span="4">服务内容：</el-col>
                  <el-col class="m-label" :span="20">
                    <span v-for="(service, index) in services" :key="index">
                      <el-tag style="margin-right: 10px">{{ service }}</el-tag>
                    </span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="m-label" :span="4">账户信息：</el-col>
                  <el-col class="m-label" :span="20">
                    <el-col
                      :span="24"
                      style="copy-col"
                      v-for="(banks, index) in bank_msg"
                      :key="index"
                    >
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style copy-col"
                          @click="copySignMsg(banks.bank + ' : ' + banks.accnumber)"
                        >
                          {{
                            banks.bank +
                            " : " +
                            banks.accnumber +
                            (banks.bank_type === 2 ? " （基本账户）" : " （一般账户）")
                          }}
                        </span>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-col :span="8" class="m-label">
                      <el-tooltip content="财税负责人" placement="top">
                        <span class="count_style" style="display: inherit"
                          >财税负责人：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style copy-col"
                          @click="
                            copySignMsg(
                              fiscal_tax
                                ? fiscal_tax.leader
                                  ? fiscal_tax.leader.username
                                  : ''
                                : ''
                            )
                          "
                        >
                          {{
                            fiscal_tax
                              ? fiscal_tax.leader
                                ? fiscal_tax.leader.username
                                : ""
                              : ""
                          }}
                        </span>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="8" class="m-label">
                      <el-tooltip content="理票会计" placement="top">
                        <span class="count_style" style="display: inherit"
                          >理票会计：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style copy-col"
                          @click="
                            copySignMsg(
                              fiscal_tax
                                ? fiscal_tax.acc
                                  ? fiscal_tax.acc.username
                                  : ''
                                : ''
                            )
                          "
                        >
                          {{
                            fiscal_tax
                              ? fiscal_tax.acc
                                ? fiscal_tax.acc.username
                                : ""
                              : ""
                          }}
                        </span>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-col :span="8" class="m-label">
                      <el-tooltip content="客服会计" placement="top">
                        <span class="count_style" style="display: inherit"
                          >客服会计：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style copy-col"
                          @click="
                            copySignMsg(
                              fiscal_tax
                                ? fiscal_tax.ass
                                  ? fiscal_tax.ass.username
                                  : ''
                                : ''
                            )
                          "
                        >
                          {{
                            fiscal_tax
                              ? fiscal_tax.ass
                                ? fiscal_tax.ass.username
                                : ""
                              : ""
                          }}
                        </span>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="8" class="m-label">
                      <el-tooltip content="记账报税会计" placement="top">
                        <span class="count_style" style="display: inherit"
                          >记账报税会计：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style copy-col"
                          @click="
                            copySignMsg(
                              fiscal_tax
                                ? fiscal_tax.advisory
                                  ? fiscal_tax.advisory.username
                                  : ''
                                : ''
                            )
                          "
                        >
                          {{
                            fiscal_tax
                              ? fiscal_tax.advisory
                                ? fiscal_tax.advisory.username
                                : ""
                              : ""
                          }}
                        </span>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-col :span="8" class="m-label">
                      <el-tooltip content="开票会计" placement="top">
                        <span class="count_style" style="display: inherit"
                          >开票会计：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style copy-col"
                          @click="
                            copySignMsg(
                              fiscal_tax
                                ? fiscal_tax.invoice
                                  ? fiscal_tax.invoice.username
                                  : ''
                                : ''
                            )
                          "
                        >
                          {{
                            fiscal_tax
                              ? fiscal_tax.invoice
                                ? fiscal_tax.invoice.username
                                : ""
                              : ""
                          }}
                        </span>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="8" class="m-label">
                      <el-tooltip content="所属业务" placement="top">
                        <span class="count_style" style="display: inherit"
                          >所属业务：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="m-label">
                      <!-- <el-tooltip content="点击复制" placement="top"> -->
                      <span class="count_style copy-col">
                        {{
                          com_msgs.dedicated_consultant &&
                          com_msgs.dedicated_consultant
                            .map((item) =>
                              item.adminuser ? item.adminuser.username : ""
                            )
                            .join(", ")
                        }}
                      </span>
                      <!-- </el-tooltip> -->
                    </el-col>
                  </el-col>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="员工信息" name="third">
                <el-row>
                  <el-col class="m-label" style="color: #409eff"
                    >{{ com_msgs.company_name }}（员工信息表）</el-col
                  >
                </el-row>
                <el-table :data="tableData" style="width: 100%" border max-height="700">
                  <el-table-column label="员工姓名">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.staff_name" placement="top">
                        <div class="company_hover">
                          <span class="count_style" style="display: inherit">
                            <el-link
                              type="primary"
                              @click="handleOpenStaffDetail(scope.row)"
                              >{{ scope.row.staff_name }}</el-link
                            >
                          </span>
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column label="入职时间">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.staff_reg_at" placement="top">
                        <span>{{ scope.row.staff_reg_at }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column label="是否在职">
                    <template slot-scope="scope">
                      <el-tooltip
                        :content="scope.row.is_inservice === 1 ? '在职' : '已离职'"
                        placement="top"
                      >
                        <span>{{
                          scope.row.is_inservice === 1 ? "在职" : "已离职"
                        }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column label="员工工资（￥）">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.staff_salary" placement="top">
                        <span>{{ scope.row.staff_salary }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column label="社保缴纳">
                    <template slot-scope="scope">
                      <el-tooltip
                        :content="scope.row.is_secuity === 1 ? '否' : '是'"
                        placement="top"
                      >
                        <span>{{ scope.row.is_secuity === 1 ? "否" : "是" }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column label="公积金缴纳">
                    <template slot-scope="scope">
                      <el-tooltip
                        :content="scope.row.is_accum === 1 ? '否' : '是'"
                        placement="top"
                      >
                        <span>{{ scope.row.is_accum === 1 ? "否" : "是" }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="员工信息修改详情"
                        placement="top"
                      >
                        <el-button
                          type="primary"
                          size="mini"
                          @click="handleOpenStaffRecord(scope.row)"
                          >记录</el-button
                        >
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="chatDrawer"
      direction="rtl"
      :before-close="handleChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <chat :chatId="chatId" :chatName="chatName"></chat>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="qyChatDrawer"
      direction="rtl"
      :before-close="handleQyChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <qy-group-chat :chatId="qyChatId" :chatName="qyChatName"></qy-group-chat>
      </div>
    </el-drawer>
    <el-drawer
      :title="'员工详情【' + companyName + '】'"
      :visible.sync="staffDrawer"
      size="50%"
    >
      <div style="margin-left: 0.4rem">
        <div class="m-tabs-content">
          <div class="blocka">
            <div style="font-size: 15px; color: #4c87fc; margin: 0.2rem">
              {{ com_msgs.company_name + "（" + StaffDetail.staff_name + "）" }}
            </div>
            <el-divider style="margin-left: 0.5rem; margin-right: 0.5rem"></el-divider>
            <div class="m-label" style="margin-bottom: 0.2rem">员工基本信息</div>
            <div style="border: solid 1px #eeeeee; border-radius: 10px; color: gray">
              <div style="margin-left: 0.2rem; margin-top: 0.2rem">
                <el-row class="m-label">
                  <!-- 第一行 -->
                  <el-col :span="12">
                    <el-col :span="6">员工姓名：</el-col>
                    <el-col :span="18">{{ StaffDetail.staff_name }}</el-col>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="6">员工工资：</el-col>
                    <el-col :span="18">{{ StaffDetail.staff_salary }}</el-col>
                  </el-col>
                  <!-- 第二行 -->
                  <el-col :span="12">
                    <el-col :span="6">社保：</el-col>
                    <el-col :span="18">{{
                      StaffDetail.is_secuity === 1 ? "不缴纳" : "缴纳"
                    }}</el-col>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="6">公积金：</el-col>
                    <el-col :span="18">{{
                      StaffDetail.is_accum === 1 ? "不缴纳" : "缴纳"
                    }}</el-col>
                  </el-col>
                  <!-- 第三行 -->
                  <el-col :span="12">
                    <el-col :span="6">手机号码：</el-col>
                    <el-col :span="18">{{ StaffDetail.staff_phone }}</el-col>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="6">身份证号：</el-col>
                    <el-col :span="18">{{ StaffDetail.staff_id_number }}</el-col>
                  </el-col>
                  <!-- 第四行 -->
                  <el-col :span="12">
                    <el-col :span="6">入职时间：</el-col>
                    <el-col :span="18">{{ StaffDetail.staff_reg_at }}</el-col>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="6">是否在职：</el-col>
                    <el-col :span="18">{{
                      StaffDetail.is_inservice === 1 ? "在职" : "离职"
                    }}</el-col>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div
              class="m-label"
              style="margin-bottom: 0.2rem; margin-top: 0.2rem"
              v-if="StaffDetail.secuity"
            >
              员工社保信息
            </div>
            <div
              style="border: solid 1px #eeeeee; border-radius: 10px; color: gray"
              v-if="StaffDetail.secuity"
            >
              <div style="margin-left: 0.2rem; margin-top: 0.2rem">
                <el-row class="m-label">
                  <!-- 第一行 -->
                  <el-col :span="24">
                    <el-col :span="6">社保基数(￥)：</el-col>
                    <el-col :span="18">{{
                      StaffDetail.secuity ? StaffDetail.secuity.secuity_base : "0.00"
                    }}</el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="6">现居地址：</el-col>
                    <el-col :span="18">{{
                      StaffDetail.secuity ? StaffDetail.secuity.address : ""
                    }}</el-col>
                  </el-col>
                </el-row>
                <el-row v-if="StaffDetail.src_list">
                  <el-col
                    :span="11"
                    v-for="(idMsg, index) in StaffDetail.src_list"
                    :key="index"
                  >
                    <el-image
                      style="width: 100%; height: 200px; border-radius; 5px;"
                      :src="idMsg"
                      :preview-src-list="StaffDetail.src_list"
                    ></el-image>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div
              class="m-label"
              style="margin-bottom: 0.2rem; margin-top: 0.2rem"
              v-if="StaffDetail.accum"
            >
              员工社保信息
            </div>
            <div
              style="border: solid 1px #eeeeee; border-radius: 10px; color: gray"
              v-if="StaffDetail.accum"
            >
              <div style="margin-left: 0.2rem; margin-top: 0.2rem">
                <el-row class="m-label">
                  <!-- 第一行 -->
                  <el-col :span="24">
                    <el-col :span="6">公积金基数(￥)：</el-col>
                    <el-col :span="18">{{
                      StaffDetail.accum ? StaffDetail.accum.accum_base : "0.00"
                    }}</el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="6">公积金账号：</el-col>
                    <el-col :span="18">{{
                      StaffDetail.accum ? StaffDetail.accum.accum_account : ""
                    }}</el-col>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div style="height: 50px"></div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      :title="'员工信息修改记录【' + companyName + '】'"
      :visible.sync="staffRecordDrawer"
      size="40%"
    >
      <div class="block">
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <el-timeline v-for="(record, index) in StaffRecords" :key="index">
            <el-timeline-item :timestamp="record.created_at" placement="top">
              <el-card>
                <p>{{ record.operate }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatName"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="录入纳税明细"
      :visible.sync="infoTaxDrawer"
      direction="rtl"
      :before-close="handleInfoTaxBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-tabs type="border-card">
          <el-tab-pane label="纳税明细">
            <el-row>
              <el-col class="mt-label">
                <el-col :span="6" :offset="1">公司名称：</el-col>
                <el-col :span="16">{{ companyName }}</el-col>
              </el-col>
              <el-col class="mt-label">
                <el-col :span="6" :offset="1">纳税月份：</el-col>
                <el-col :span="16">{{ taxAddData.month }}</el-col>
              </el-col>
              <span v-if="!isTaxTotal">
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >增值税（{{
                      tax_payment && tax_payment.added_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.added_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12"
                    ><el-input
                      v-model="taxAddData.added_tax"
                      size="mini"
                      :disabled="handleGetReadonly('added_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入增值税金额"
                      ><template slot="append">元</template></el-input
                    ></el-col
                  >
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >附加税（{{
                      tax_payment && tax_payment.addtional_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.addtional_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12"
                    ><el-input
                      v-model="taxAddData.addtional_tax"
                      size="mini"
                      :disabled="handleGetReadonly('addtional_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入附加税金额"
                      ><template slot="append">元</template></el-input
                    ></el-col
                  >
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >个人所得税（{{
                      tax_payment && tax_payment.person_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.person_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12"
                    ><el-input
                      v-model="taxAddData.person_tax"
                      size="mini"
                      :disabled="handleGetReadonly('person_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入个人所得税金额"
                      ><template slot="append">元</template></el-input
                    ></el-col
                  >
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >企业所得税（{{
                      tax_payment && tax_payment.company_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.company_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12"
                    ><el-input
                      v-model="taxAddData.company_tax"
                      size="mini"
                      :disabled="handleGetReadonly('company_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入企业所得税金额"
                      ><template slot="append">元</template></el-input
                    ></el-col
                  >
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >印花税（{{
                      tax_payment && tax_payment.stamp_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.stamp_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12"
                    ><el-input
                      v-model="taxAddData.stamp_tax"
                      size="mini"
                      :disabled="handleGetReadonly('stamp_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入印花税金额"
                      ><template slot="append">元</template></el-input
                    ></el-col
                  >
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >生产经营个税（{{
                      tax_payment && tax_payment.bussin_tax_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.bussin_tax_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12"
                    ><el-input
                      v-model="taxAddData.bussin_tax"
                      size="mini"
                      :disabled="handleGetReadonly('bussin_tax_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入生产经营个税金额"
                      ><template slot="append">元</template></el-input
                    ></el-col
                  >
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >房产税（{{
                      tax_payment && tax_payment.house_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.house_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12"
                    ><el-input
                      v-model="taxAddData.house_tax"
                      size="mini"
                      :disabled="handleGetReadonly('house_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入房产税金额"
                      ><template slot="append">元</template></el-input
                    ></el-col
                  >
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >财务报表（{{
                      tax_payment && tax_payment.finance_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.finance_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-radio-group
                      v-model="taxAddData.is_table"
                      size="mini"
                      :disabled="handleGetReadonly('finance_set')"
                    >
                      <el-radio label="1" border>未上报</el-radio>
                      <el-radio label="2" border>已上报</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1">总金额：</el-col>
                  <el-col :span="12">{{ tatalTaxMoney }}元</el-col>
                </el-col>
                <el-col class="mt-10 tr">
                  <el-button type="primary" size="mini" @click="handleAddTaxDetail"
                    >添加</el-button
                  >
                </el-col>
              </span>
              <span v-else>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >增值税（{{
                      tax_payment && tax_payment.added_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.added_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-input
                      v-model="taxAddData.added_tax"
                      :disabled="handleGetReadonly('added_set')"
                      size="mini"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @change="handleSaveTaxDetail('added_tax')"
                      placeholder="请输入增值税金额"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >附加税（{{
                      tax_payment && tax_payment.addtional_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.addtional_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-input
                      v-model="taxAddData.addtional_tax"
                      size="mini"
                      :disabled="handleGetReadonly('addtional_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @change="handleSaveTaxDetail('addtional_tax')"
                      placeholder="请输入附加税金额"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >个人所得税（{{
                      tax_payment && tax_payment.person_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.person_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-input
                      v-model="taxAddData.person_tax"
                      size="mini"
                      :disabled="handleGetReadonly('person_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @change="handleSaveTaxDetail('person_tax')"
                      placeholder="请输入个人所得税金额"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >企业所得税（{{
                      tax_payment && tax_payment.company_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.company_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-input
                      v-model="taxAddData.company_tax"
                      size="mini"
                      :disabled="handleGetReadonly('company_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @change="handleSaveTaxDetail('company_tax')"
                      placeholder="请输入企业所得税金额"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >印花税（{{
                      tax_payment && tax_payment.stamp_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.stamp_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-input
                      v-model="taxAddData.stamp_tax"
                      size="mini"
                      :disabled="handleGetReadonly('stamp_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @change="handleSaveTaxDetail('stamp_tax')"
                      placeholder="请输入印花税金额"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >生产经营个税（{{
                      tax_payment && tax_payment.bussin_tax_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.bussin_tax_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-input
                      v-model="taxAddData.bussin_tax"
                      size="mini"
                      :disabled="handleGetReadonly('bussin_tax_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @change="handleSaveTaxDetail('bussin_tax')"
                      placeholder="请输入生产经营个税金额"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >房产税（{{
                      tax_payment && tax_payment.house_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.house_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-input
                      v-model="taxAddData.house_tax"
                      size="mini"
                      :disabled="handleGetReadonly('house_set')"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @change="handleSaveTaxDetail('house_tax')"
                      placeholder="请输入房产税金额"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1"
                    >财务报表（{{
                      tax_payment && tax_payment.finance_set === 1
                        ? "月报"
                        : tax_payment && tax_payment.finance_set === 2
                        ? "季报"
                        : "无"
                    }}）：</el-col
                  >
                  <el-col :span="12">
                    <el-radio-group
                      v-model="taxAddData.is_table"
                      size="mini"
                      :disabled="handleGetReadonly('finance_set')"
                      @change="handleSaveTaxDetail('is_table')"
                      placeholder="请选择财务报表是否上报"
                    >
                      <el-radio label="1" border>未上报</el-radio>
                      <el-radio label="2" border>已上报</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-col>
                <el-col class="mt-label">
                  <el-col :span="6" :offset="1">总金额：</el-col>
                  <el-col :span="12">{{ tatalTaxMoney }}元</el-col>
                </el-col>
              </span>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <!-- 支付人详情及公司情况 开始 -->
    <el-drawer
      title="支付人详情及公司概况"
      :visible.sync="handlePayerContentDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="50%"
      class="PayerContent"
    >
      <!-- 组件调用 -->
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <userwith-order
            :PayerData="userData"
            :ThreadData="ThreadData"
            :PayerCompanyData="PayerCompanyData"
            :userOrderData="userOrderData"
          ></userwith-order>
        </el-row>
      </div>
      <!-- 组件调用 -->
    </el-drawer>
    <!-- 支付人详情及公司情况 结束 -->
    <!-- 沟通记录弹窗 开始-->
    <el-drawer
      title="沟通记录"
      :visible.sync="chatRecordDrawer"
      direction="rtl"
      :before-close="handleChatRecordBeforeClose"
      size="40%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 结束-->
  </el-container>
</template>
<script>
import upfile from "../../common/UpFile.vue";
import Chat from "common/Chat";
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import QyGroupChat from "common/QyGroupChat";
import TaxAdvice from "common/TaxAdvice";
import UserwithOrder from "common/UserWithOrder";
import ChatRecord from "common/ChatRecord";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "FinanceInfo",
  components: {
    upfile,
    Chat,
    WxWorkChat,
    CallLogs,
    QyGroupChat,
    TaxAdvice,
    UserwithOrder,
    ChatRecord,
  },
  data() {
    return {
      addAddressForm: {
        addressee: 2,
        group: 3,
      },
      handlePayerContentDrawer: false,
      PayerCompanyData: [],
      userOrderData: [],
      payerShowTab: "1",
      companyInfoDrawer: false,
      ThreadData: {},
      userData: {},
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
      is_send: "",
      title: "",
      image_url: "",
      chatCompany: "",
      companyId: null,
      companyName: "",
      yesterday: "",
      tatalTaxMoney: 0,
      site_url: "https://weixin.qiyehuo.com",
      imgPath: "https://www.qiyehuo.com/uploads/adminuser/",
      activeName: 1,
      chatDrawer: false,
      showTabPane: "first",
      dateTime: "",
      isTaxTotal: false,
      searchArr: {
        company_id: "",
        is_confirm: "",
        leader_id: "",
        acc_id: "",
        ass_id: "",
        saler_id: "",
        advisory_id: "",
        invoice_id: "",
        is_bind: "",
        is_subscribe: "",
        is_express: "",
        is_files: "",
        archives: "",
      },
      taxAddData: {
        index: null,
        cid: null,
        month: "",
        added_tax: null,
        addtional_tax: null,
        person_tax: null,
        company_tax: null,
        stamp_tax: null,
        house_tax: null,
        bussin_tax: null,
        is_table: null,
      },
      loading: false,
      staffDrawer: false,
      infoTaxDrawer: false,
      batchDialog: false,
      questionVisible: false,
      adviceComId: null,
      adviceComName: null,
      categoryIndrawer: false,
      tableData: [],
      StaffDetail: [],
      StaffRecords: [],
      idImageList: [],
      allusers: [],
      tax_payment: [],
      companies: [],
      financeInfo: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
        pageSizes: [10, 20, 30, 50, 100, 500],
      },
      searchVisible: false,
      dialogVisible: false,
      uploadingDrawer: false,
      staffRecordDrawer: false,
      uploadingSaveDrawer: false,
      uploadingSuccessDrawer: false,
      backCluesDrawer: false,
      addForm: {
        declare_month: "",
        user_remark: "",
        company_id: null,
        index: null,
      },
      addRules: {
        declare_month: [{ required: true, message: "请选择月份", trigger: "blur" }],
      },
      saveForm: {
        declare_month: "",
        user_remark: "",
        company_id: null,
        index: null,
      },
      licenseSaveImg: "",
      saveRules: {
        declare_month: [{ required: true, message: "请选择月份", trigger: "blur" }],
      },
      addSuccessForm: {
        declare_month: "",
        company_id: null,
        user_remark: "",
        index: null,
      },
      addSuccessRules: {
        declare_month: [{ required: true, message: "请选择月份", trigger: "blur" }],
      },
      informForm: {
        company_id: null,
        declare_month: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      licenseList: [],
      licenseSaveList: [],
      licenseSuccessList: [],
      list_month: "",
      row: {},
      OperationRecord: [],
      previewImageUrl: [],
      formData: null,
      batchArr: [],
      services: [],
      bank_msg: [],
      com_msgs: [],
      fiscal_tax: [],
      chatId: "",
      chatName: "",
      wxChatDrawer: false,
      wxWorkChatId: "",
      wxWorkchatName: "",
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      qyChatDrawer: false,
      qyChatId: "",
      qyChatName: "",
      addressRules: {
        addressee: [{ required: true, message: "请选择公司位置", trigger: "blur" }],
        group: [{ required: true, message: "请选择分组位置", trigger: "blur" }],
      },
      additionalData: { value: "无", label: "NULL" },
    };
  },
  watch: {
    "taxAddData.added_tax": function () {
      this.getTotalMoney();
    },
    "taxAddData.addtional_tax": function () {
      this.getTotalMoney();
    },
    "taxAddData.person_tax": function () {
      this.getTotalMoney();
    },
    "taxAddData.company_tax": function () {
      this.getTotalMoney();
    },
    "taxAddData.stamp_tax": function () {
      this.getTotalMoney();
    },
    "taxAddData.bussin_tax": function () {
      this.getTotalMoney();
    },
    "taxAddData.house_tax": function () {
      this.getTotalMoney();
    },
  },
  computed: {
    pageData: function () {
      return this.financeInfo;
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    allusersAddition() {
      return [...this.allusers, this.additionalData];
    },
  },
  methods: {
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    // 展示支付人信息及公司情况
    handleShowPayerContent(row) {
      this.ThreadData = row.user.publicthread;
      this.userData = row.user;
      this.PayerCompanyData = row.user.company;
      if (this.PayerCompanyData.length !== 0) {
        for (let item of this.PayerCompanyData) {
          item.business_man = row.user.business.username;
        }
      }
      this.handelOpenUserOrder(row.user);
      this.handlePayerContentDrawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.PayerData = [];
          this.handlePayerContentDrawer = false;
          this.payerShowTab = "1";
          done();
        })
        .catch((_) => {});
    },
    // 控制用户关联订单信息展示与隐藏
    handelOpenUserOrder(row) {
      this.$axios.post("/api/customer/get_customer_order", { id: row.id }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.userOrderData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true;
      setTimeout(() => {
        this.threadId = threadId;
      });
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false;
      this.threadId = null;
      done();
    },
    batchInform() {
      this.batchDialog = true;
    },
    getTotalMoney() {
      let addedTax = 0;
      let addtionalTax = 0;
      let personTax = 0;
      let companyTax = 0;
      let stampTax = 0;
      let bussinTax = 0;
      let houseTax = 0;
      if (this.taxAddData.added_tax) {
        addedTax = parseFloat(this.taxAddData.added_tax);
      }
      if (this.taxAddData.addtional_tax) {
        addtionalTax = parseFloat(this.taxAddData.addtional_tax);
      }
      if (this.taxAddData.person_tax) {
        personTax = parseFloat(this.taxAddData.person_tax);
      }
      if (this.taxAddData.company_tax) {
        companyTax = parseFloat(this.taxAddData.company_tax);
      }
      if (this.taxAddData.stamp_tax) {
        stampTax = parseFloat(this.taxAddData.stamp_tax);
      }
      if (this.taxAddData.bussin_tax) {
        bussinTax = parseFloat(this.taxAddData.bussin_tax);
      }
      if (this.taxAddData.house_tax) {
        houseTax = parseFloat(this.taxAddData.house_tax);
      }
      this.tatalTaxMoney =
        addedTax +
        addtionalTax +
        personTax +
        companyTax +
        stampTax +
        bussinTax +
        houseTax;
    },
    batchSendInform() {
      if (!this.dateTime) {
        this.$message.error("请选择月份");
        return;
      }
      this.$axios
        .post("/api/fin_info/batch_inform", {
          dateTime: this.dateTime,
          batchArr: this.batchArr,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1002) {
            this.$message.error(data.msg);
          }
          this.$message.success(data.msg);
          this.getPageData();
        });
      this.batchDialog = false;
    },
    handleChatBeforeClose(done) {
      this.clearChatsData();
      done();
    },
    clearChatsData() {
      this.chatId = "";
      this.chatName = "";
    },
    handleQyChatBeforeClose(done) {
      this.qyChatId = "";
      this.qyChatName = "";
      done();
    },
    handleCloseIn(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          setTimeout(() => {
            this.adviceComId = null;
            // this.$refs.categoryForm.resetFields()
            // this.$refs.uploadMutiple.clearFiles()
            this.needUrl = [];
          });
          done();
        })
        .catch((_) => {});
    },
    handleOpenStaffDetail(row) {
      this.StaffDetail = [];
      this.$axios.get("/api/staff_msg/detail/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.StaffDetail = data.data.detail;
        }
      });
      this.staffDrawer = true;
    },
    handleOpenStaffRecord(row) {
      this.StaffRecords = [];
      this.$axios
        .get("/api/staff_msg/records/" + row.company_id + "/" + row.id)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.StaffRecords = data.data.records;
          }
        });
      this.staffRecordDrawer = true;
    },
    handleChangeIsSendWxMsg() {
      this.$axios.post("/api/wx_msg/set_send", { is_send: this.is_send }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        }
      });
    },
    handleQyChatOpen(chat, chatName) {
      if (chat) {
        this.qyChatDrawer = true;
        setTimeout(() => {
          this.qyChatId = chat.chat_id;
          this.qyChatName = chatName;
        });
      }
    },
    handleChatOpen(chat, chatName) {
      if (chat) {
        this.chatDrawer = true;
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatName = chatName;
        });
      }
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkChatName = companyName;
        });
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkChatName = "";
      done();
    },
    getYearMonth() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      if (month === 1) {
        year = year - 1;
        month = 12;
      } else {
        month = month - 1;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return year + "-" + month;
    },
    getDecalreMonth() {
      let month = this.getYearMonth();
      this.addForm.declare_month = month;
      this.saveForm.declare_month = month;
      this.addSuccessForm.declare_month = month;
      this.informForm.declare_month = month;
    },
    handleCompanyChange(val) {
      if (this.searchArr.dateTime) {
        this.addForm.declare_month = this.searchArr.dateTime;
        this.saveForm.declare_month = this.searchArr.dateTime;
        this.addSuccessForm.declare_month = this.searchArr.dateTime;
        this.informForm.declare_month = this.searchArr.dateTime;
      } else {
        this.getDecalreMonth();
      }
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    // 申报前编辑图片
    handleEditImg(row, index) {
      this.uploadingSaveDrawer = true;
      this.row = row;
      this.saveForm.declare_month = row.state.month;
      this.saveForm.company_id = row.id;
      this.saveForm.index = index;
      this.formData = new FormData();
    },
    // 申报前上传图片窗口
    handleUploadImg(row, index) {
      console.log(row);
      if (!row.inform) {
        this.$message.error("请先通知客户邮递或上传资料！");
        return;
      }
      this.uploadingDrawer = true;
      this.row = row;
      this.addForm.index = index;
      this.addForm.company_id = row.id;
      this.formData = new FormData();
      this.companyName = row.company_name;
    },
    // 查看申报前照片
    handlePreviewImg(row, index) {
      if (row.revamp.length) {
        window.open(row.revamp[0].image_url);
        return;
      }
      window.open(row.upload.image_url);
    },
    // 申报成功上传照片窗口
    handleUploadImgSuccess(row, index) {
      if (!row.upload) {
        this.$message.error("请先上传申报截图！");
        return;
      }
      this.uploadingSuccessDrawer = true;
      this.row = row;
      this.addSuccessForm.index = index;
      this.addSuccessForm.company_id = row.id;
      this.formData = new FormData();
    },
    // 申报成功照片
    handlePreviewImgSuccess(row, index) {
      // this.image_url = row.success.image_url
      // this.dialogVisible = true
      window.open(row.success.image_url);
    },
    getPageData() {
      this.$axios
        .get(
          "/api/fin_info/list?page=" +
            this.pageOption.currentPage +
            "&limit=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          this.financeInfo = data.data.list.data;
          this.list_month = data.data.month;
          this.allusers = data.data.users;
          if (data.data.is_send) {
            this.is_send = data.data.is_send;
          }
          this.pageOption.total = data.data.list.total;
          this.pageOption.currentPage = data.data.list.current_page;
          this.batchArr = [];
          for (let key in this.financeInfo) {
            this.batchArr.push(this.financeInfo[key].id);
          }
          console.log(this.batchArr);
        });
    },
    handleSearchGetData() {
      this.searchVisible = false;
      this.getPageData();
    },
    handleClearSearchGetData() {
      this.searchArr.leader_id = "";
      this.searchArr.acc_id = "";
      this.searchArr.ass_id = "";
      this.searchArr.saler_id = "";
      this.searchArr.advisory_id = "";
      this.searchArr.invoice_id = "";
      this.searchArr.is_bind = "";
      this.searchArr.is_subscribe = "";
      this.searchArr.is_express = "";
      this.searchArr.is_files = "";
      this.searchArr.archives = "";
      this.searchVisible = false;
      this.getPageData();
    },
    // 通知客户回传报税资料
    handleInform(row, index) {
      this.informForm.company_id = row.id;
      this.$axios.post("/api/fin_info/inform", this.informForm).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.financeInfo[index].state = data.data.data[0].state;
          this.financeInfo[index].inform = data.data.data[0].inform;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 申报前上传
    submitAddUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.licenseList.length === 0) {
            this.$message.error("请上传申报图片");
            return;
          }
          this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key]);
          }
          this.$axios.post("/api/fin_info/upload", this.formData).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.$message.success(data.msg);
              this.financeInfo[this.addForm.index].state = data.data.data[0].state;
              this.financeInfo[this.addForm.index].upload = data.data.data[0].upload;
              this.uploadingDrawer = false;
              this.companyName = "";
              this.resetRechargeForm("addForm");
              this.licenseList = [];
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    // 申报后编辑
    submitSaveUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.licenseSaveList.length === 0) {
            this.$message.error("请上传要替换的照片");
            return;
          }
          this.licenseSaveList.forEach((file) =>
            this.formData.append("file[]", file.raw)
          );
          for (let key in this.saveForm) {
            this.formData.append(key, this.saveForm[key]);
          }
          this.$axios
            .post("/api/fin_info/update/" + this.row.state.id, this.formData)
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.$message.success(data.msg);
                this.financeInfo[this.saveForm.index].state = data.data.data[0].state;
                this.financeInfo[this.saveForm.index].upload = data.data.data[0].upload;
                this.financeInfo[this.saveForm.index].revamp = data.data.data[0].revamp;
                this.uploadingSaveDrawer = false;
                this.resetRechargeForm("saveForm");
                this.licenseSaveFormList = [];
              } else {
                this.$message.error(data.msg);
              }
            });
        }
      });
    },
    // 申报成功后上传
    submitAddSuccessUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.licenseSuccessList.length === 0) {
            this.$message.error("请上传要替换的照片");
            return;
          }
          this.licenseSuccessList.forEach((file) =>
            this.formData.append("file[]", file.raw)
          );
          for (let key in this.addSuccessForm) {
            this.formData.append(key, this.addSuccessForm[key]);
          }

          this.$axios
            .post("/api/fin_info/success/" + this.row.state.id, this.formData)
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.$message.success(data.msg);
                this.financeInfo[this.addSuccessForm.index].state =
                  data.data.data[0].state;
                this.financeInfo[this.addSuccessForm.index].upload =
                  data.data.data[0].upload;
                this.financeInfo[this.addSuccessForm.index].success =
                  data.data.data[0].success;
                this.uploadingSuccessDrawer = false;
                this.resetRechargeForm("addSuccessForm");
                this.licenseSuccessList = [];
              } else {
                this.$message.error(data.msg);
              }
            });
        }
      });
    },
    handelSearch() {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageData();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageData();
    },
    // 上传
    handleLicensePreview(file) {},
    handleLicenseChange(file, fileList) {
      this.licenseList = fileList;
    },
    handleLicenseRemove(file, fileList) {
      this.licenseList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    // 修改
    handleLicenseSavePreview(file) {},
    handleLicenseSaveChange(file, fileList) {
      this.licenseSaveList = fileList;
    },
    handleLicenseSaveRemove(file, fileList) {
      this.licenseSaveList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseSaveList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.saveForm) {
        this.formData.append(key, this.saveForm[key]);
      }
    },
    // 申报成功上传图片
    handleLicenseSuccessPreview(file) {},
    handleLicenseSuccessChange(file, fileList) {
      this.licenseSuccessList = fileList;
    },
    handleLicenseSuccessRemove(file, fileList) {
      this.licenseSuccessList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseSuccessList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addSuccessForm) {
        this.formData.append(key, this.addSuccessForm[key]);
      }
    },
    handleAddClose(done) {
      this.resetRechargeForm("addForm");
      this.licenseList = [];
      done();
      this.formData = null;
      this.companyName = "";
    },
    handleSaveClose(done) {
      this.resetRechargeForm("saveForm");
      this.licenseSaveList = [];
      done();
      this.formData = null;
    },
    handleAddSuccessClose(done) {
      this.resetRechargeForm("addSuccessForm");
      this.licenseSuccessList = [];
      done();
      this.formData = null;
    },
    handleAddDrawerBeforeClose(done) {
      done();
    },
    handleTaxAdvice(row, index) {
      this.adviceComId = row.id;
      this.adviceComName = row.company_name;
      this.categoryIndrawer = true;
    },
    resetRechargeForm(formName) {
      this.$refs[formName].resetFields();
      this.licenseList = [];
      this.licenseSaveList = [];
      this.licenseSuccessList = [];
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleOpen(id, cname, index) {
      this.backCluesDrawer = true;
      this.companyName = cname;
      this.showTabPane = "first";
      this.$axios.get("/api/fin_info/record/" + id).then((res) => {
        const { data } = res;
        this.OperationRecord = data.data.records;
        this.services = data.data.com_msg.services;
        this.bank_msg = data.data.com_msg.bank_msg;
        this.com_msgs = data.data.com_msg.com_msgs;
        this.fiscal_tax = data.data.com_msg.fiscal_tax;
      });
      this.getStaffMsg(id);
    },
    getStaffMsg(cid) {
      this.$axios.get("/api/staff_msg/list?company_id=" + cid).then((res) => {
        const { data } = res;
        this.tableData = data.data.list;
      });
    },
    pickerDataChangeUpload(val) {
      if (val) {
        this.addForm.declare_month = val;
      } else {
        this.addForm.declare_month = "";
      }
    },
    pickerDataChangeRevamp(val) {
      if (val) {
        this.saveForm.declare_month = val;
      } else {
        this.saveForm.declare_month = "";
      }
    },
    pickerDataChangeSuccess(val) {
      if (val) {
        this.addSuccessForm.declare_month = val;
      } else {
        this.addSuccessForm.declare_month = "";
      }
    },
    // 文件下载
    downloadFile(url) {
      window.open(this.site_url + url);
    },
    copySignMsg(str) {
      let oInput = document.createElement("input");
      oInput.value = str;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList.length < 5) {
            that.licenseList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleUpdateParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseSaveList.length < 5) {
            that.licenseSaveList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleSuccessParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };
          if (that.licenseSuccessList.length < 5) {
            that.licenseSuccessList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    getDisabledStatus(rows) {
      if (!rows.inform) {
        return false;
      }
      // 通知记录的时间戳
      let timestamp = new Date(rows.inform.created_at).getTime();
      let yesterday = new Date().getTime() - 24 * 60 * 60 * 1000;
      if (timestamp < yesterday) {
        return false;
      }
      return true;
    },
    copyStr(needStr) {
      let oInput = document.createElement("input");
      oInput.value = needStr;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.orders.length > 0) {
          for (var i = 0; i < row.orders.length; i++) {
            if (
              row.orders[i].customer_phone &&
              this.callPhone1.indexOf(row.orders[i].customer_phone) === -1
            )
              this.callPhone1.push(row.orders[i].customer_phone);
            if (
              row.orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.orders[i].corporate_phone) === -1
            )
              this.callPhone2.push(row.orders[i].corporate_phone);
          }
        }
      });
    },
    handleAddTaxDetail() {
      if (!this.taxAddData.added_tax && this.handleGetReadonly("added_set") === false) {
        this.$message.error("请填写增值税金额");
        return;
      }
      if (
        !this.taxAddData.addtional_tax &&
        this.handleGetReadonly("addtional_set") === false
      ) {
        this.$message.error("请填写附加税金额");
        return;
      }
      if (!this.taxAddData.person_tax && this.handleGetReadonly("person_set") === false) {
        this.$message.error("请填写个人所得税金额");
        return;
      }
      if (
        !this.taxAddData.company_tax &&
        this.handleGetReadonly("company_set") === false
      ) {
        this.$message.error("请填写企业所得税金额");
        return;
      }
      if (!this.taxAddData.stamp_tax && this.handleGetReadonly("stamp_set") === false) {
        this.$message.error("请填写印花税金额");
        return;
      }
      if (
        !this.taxAddData.bussin_tax &&
        this.handleGetReadonly("bussin_tax_set") === false
      ) {
        this.$message.error("请填写生产经营个税金额");
        return;
      }
      if (!this.taxAddData.house_tax && this.handleGetReadonly("house_set") === false) {
        this.$message.error("请填写房产税金额");
        return;
      }
      if (!this.taxAddData.is_table && this.handleGetReadonly("finance_set") === false) {
        this.$message.error("请选择财务报表是否上报");
        return;
      }
      this.$axios.post("/api/fin_info/tax_add", this.taxAddData).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.infoTaxDrawer = false;
          this.financeInfo[this.taxAddData.index].tax_total = data.data.record;
          this.handleInfoTaxBeforeClose();
        } else {
          this.$message.error("保存失败，请重试");
        }
      });
    },
    handleSaveTaxDetail(field) {
      this.$axios
        .post("/api/fin_info/tax_save/" + this.taxAddData.id, {
          field: field,
          value: this.taxAddData[field],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.infoTaxDrawer = false;
            this.financeInfo[this.taxAddData.index].tax_total = data.data;
            this.handleInfoTaxBeforeClose();
          } else {
            this.$message.error("保存失败，请重试");
          }
        });
    },
    handleTaxDetail(row, index) {
      this.companyName = row.company_name;
      this.taxAddData.cid = row.id;
      this.taxAddData.index = index;
      this.tax_payment = [];
      if (row.tax_payment) {
        this.tax_payment = row.tax_payment;
      }
      if (row.tax_total) {
        this.taxAddData.id = row.tax_total.id;
        this.taxAddData.month = row.tax_total.month;
        this.taxAddData.added_tax = row.tax_total.added_tax;
        this.taxAddData.addtional_tax = row.tax_total.addtional_tax;
        this.taxAddData.person_tax = row.tax_total.person_tax;
        this.taxAddData.company_tax = row.tax_total.company_tax;
        this.taxAddData.stamp_tax = row.tax_total.stamp_tax;
        this.taxAddData.bussin_tax = row.tax_total.bussin_tax;
        this.taxAddData.house_tax = row.tax_total.house_tax;
        this.taxAddData.is_table = row.tax_total.is_table;
        this.isTaxTotal = true;
      } else {
        if (this.searchArr.dateTime) {
          this.taxAddData.month = this.searchArr.dateTime;
        } else {
          this.taxAddData.month = this.list_month;
        }
      }
      this.infoTaxDrawer = true;
    },
    handleInfoTaxBeforeClose() {
      this.infoTaxDrawer = false;
      this.isTaxTotal = false;
      this.taxAddData.id = null;
      this.taxAddData.cid = null;
      this.taxAddData.month = "";
      this.taxAddData.added_tax = null;
      this.taxAddData.index = null;
      this.taxAddData.addtional_tax = null;
      this.taxAddData.person_tax = null;
      this.taxAddData.company_tax = null;
      this.taxAddData.stamp_tax = null;
      this.taxAddData.bussin_tax = null;
      this.taxAddData.house_tax = null;
      this.taxAddData.is_table = null;
      this.tatalTaxMoney = 0;
      this.companyName = "";
    },
    handleGetReadonly(strName) {
      if (!this.tax_payment) {
        return;
      }
      let monthArr = ["01", "04", "07", "10"];
      let inarr = monthArr.indexOf(this.list_month.slice(5, 7));
      if (strName === "added_set") {
        if (this.tax_payment.added_set === 2) {
          return inarr === -1;
        } else if (this.tax_payment.added_set === 3) {
          return true;
        } else {
          return false;
        }
      }
      if (strName === "addtional_set") {
        if (this.tax_payment.addtional_set === 2) {
          return inarr === -1;
        } else if (this.tax_payment.addtional_set === 3) {
          return true;
        } else {
          return false;
        }
      }
      if (strName === "person_set") {
        if (this.tax_payment.person_set === 2) {
          return inarr === -1;
        } else if (this.tax_payment.person_set === 3) {
          return true;
        } else {
          return false;
        }
      }
      if (strName === "bussin_tax_set") {
        if (this.tax_payment.bussin_tax_set === 2) {
          return inarr === -1;
        } else if (this.tax_payment.bussin_tax_set === 3) {
          return true;
        } else {
          return false;
        }
      }
      if (strName === "company_set") {
        if (this.tax_payment.company_set === 2) {
          return inarr === -1;
        } else if (this.tax_payment.company_set === 3) {
          return true;
        } else {
          return false;
        }
      }
      if (strName === "stamp_set") {
        if (this.tax_payment.stamp_set === 2) {
          return inarr === -1;
        } else if (this.tax_payment.stamp_set === 3) {
          return true;
        } else {
          return false;
        }
      }
      if (strName === "house_set") {
        if (this.tax_payment.house_set === 2) {
          return inarr === -1;
        } else if (this.tax_payment.house_set === 3) {
          return true;
        } else {
          return false;
        }
      }
      if (strName === "finance_set") {
        if (this.tax_payment.finance_set === 2) {
          return inarr === -1;
        } else if (this.tax_payment.finance_set === 3) {
          return true;
        } else {
          return false;
        }
      }
    },
    handleAlertAddFinance() {
      this.$message.warning("请先到财务登记表中设置当前公司的纳税明细申报周期！");
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
  mounted() {
    this.getDecalreMonth();
    this.getPageData();
    this.$bus.$on("ysy_import_servicer", (needUrl) => {
      // this.needUrl = needUrl
      this.$bus.$emit("ysyclearrm");
    });
  },
  beforeDestroy() {
    this.$bus.$off("ysy_import_servicer");
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.finance_info >>> .success-row
  background: #f0f9eb
.finance_info >>> .el-table__header th
  color: #333
  background-color: #ecf4ff
.public
  display flex
  width 100%;
  box-sizing border-box
.finance_info
  padding: 1.42rem .4rem .4rem .4rem
  max-height: 100vh
  .header-style
    height: 116px !important
    padding: 0px !important
  .main-style
    padding: 0px !important
    // overflow-y: auto
  .footer-style
    text-align: right
    .el-pagination
      padding-top: 15px
  .drawer-content
    padding: 0 .4rem 0 .4rem
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .text-r
    text-align: right
  .popover_span
    .el-position
      font-family: Arial, "Microsoft Yahei", "Helvetica Neue", Helvetica, sans-serif;
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .icon-qingtonghuiyuan
    color: #E9935D;
  .icon-baiyinhuiyuan
    color: #E6E8FA
  .icon-huangjinhuiyuan
    color: #FFD32F;
  .icon-qingtong
    color: #40BBEC
  .icon-zuanshi
    color: #83A4FF;
  .icon-wangzhe
    color: #A8A8A8
  .el-icon-chat-dot-square
    color: #88D023
.el-drawer__wrapper >>> .el-drawer__header span
  color: #4c87fc
  font-size 0.36rem
  font-weight 400
.el-drawer__wrapper >>> .el-timeline-item__wrapper
  top 0
.top_hint
  height .8rem
  line-height .8rem
  background #ECF4FF
  span
    color: #5787FF
.m-label-top
  line-height: 35px
.mb-10
  margin-bottom: .2rem
  margin-top: 0.4rem;
.mt-10
  margin-top: .2rem
.level
  display flex
  align-items center
  position relative
  padding-right .32rem
  img
    width .32rem
    height .30rem
  .el-icon-question
    margin-left: .1rem
    color: #409EFF
    position absolute
    top 0
    right 0
    cursor pointer
.count
  padding-left: .2rem
  line-height: .56rem

.tr
  text-align: right

.popoverList
  height auto
  overflow-y auto
  padding-top .2rem
  padding-left .2rem
  box-sizing border-box

  .time_right
    width 100%
    margin-top .4rem
    overflow hidden
    word-break break-all
    white-space normal
.m-tabs-content
  overflow-y auto
  .image
    width 2rem
    height 2rem
    border-radius 3px
  .listClues
    flex-direction row
    justify-content space-between
    margin-bottom .4rem
    .counts
      display inherit
      width 25%;
      line-height: .56rem;
      margin-right .2rem
      color: #000
      .listCluesTitle
        font-weight bold
  .tabs_line
    display flex
    .lines
      width .06rem
      height .30rem
      background #4C87FC
      margin-right .1rem
    .tabs-title
      color: #000000
      font-weight bold
  .tabs-title-color
    color #4C87FC
    height .8rem
    line-height .8rem
    border-bottom 1px solid #E2E2E2
    margin-bottom .6rem
  .m-label
    line-height: .50rem
  .text_right
    text-align left
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
.el-select, .el-cascader
  width: 100%
.bottom-btn
  padding: .2rem
  text-align: right
.clues >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.popovers span
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.el-position
  position relative
  .dot
    display inline-block
    width 0.1rem
    height 0.1rem
    border-radius 50%
    margin-right 0.1rem
    position absolute
    top 0
    left -.2rem
    bottom 0
    margin auto
.history_feedback
  display flex
  align-items center
  .line
    width .06rem
    height .30rem
    background #4C87FC
    margin-right .1rem
  span
    color: #424242
    font-size .30rem

.block
  height auto
  overflow-y auto
  padding-top .2rem
  padding-left .2rem
  box-sizing border-box
  .m_comment
    padding .2rem .4rem
    flex-direction column
    margin-bottom .2rem
    background #f3f3f3
    height auto
    border-radius .09rem
    .comment_name_time
      margin-bottom .4rem
      display flex
      flex-direction row
      justify-content space-between
      line-height .5rem
      span
        color: rgb(102, 102, 102)
  .time_right
    width 100%
    margin-top .4rem
    overflow hidden
    word-break break-all
    white-space normal
.handleLinkImg
  margin-right 0.2rem
.handleLinkImg:nth-last-child(1)
  margin-right 0
.el-timeline-item__node--large
  width .4rem
  height .4rem
/*滚动条整体样式*/
::-webkit-scrollbar{
  width: .1rem;/*竖向滚动条的宽度*/
  height: 10px;/*横向滚动条的高度*/

}
::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
  background: #cdcdcd;
  border-radius: 5px;
}
::-webkit-scrollbar-track{/*滚动条轨道的样式*/
  background: #f8f8f8;
  border-radius: 5px;
}
.good
  webkit-box-shadow: 0 0 10px rgba(0,0,0,.12);
  box-shadow: 0 0 10px rgba(0,0,0,.12);
.contents
  margin-bottom .4rem
  .radios.is-bordered
    margin-bottom .2rem
    margin-left 0
  .tables
    width 100%
    display flex
    height 0.88rem
    align-items center
    box-sizing border-box
    border-bottom: 1px solid  #EBEEF5
    padding 0 .2rem
    .spans
      color: #333
      font-weight bold
.contents .tables:nth-last-child(1)
  border-bottom: 0
.copy-col
  color: #409EFF
  cursor: pointer
  display: inherit
.dialog-footer
  display block
  position: absolute;
  right .4rem
  bottom .2rem

.changeHeight
  padding .2rem
  margin-top .4rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-collapse >>> .el-collapse-item__content
  padding-bottom 0

.el_dialogs >>> .el-dialog__body
  padding-left 0
  padding-right 0
.el_dialogs >>> .el-dialog__header
  padding 0
.box_title
  margin-bottom .4rem
  padding-left .6rem
  span
    font-size 0.32rem
    color: #333
    font-weight bold
.dialog_box
  padding-left 1.45rem
  padding-right 1.45rem
  .box_p
    font-size .28rem
    line-height .7rem
    color: #666666
  img
    width 100%
    margin-top .4rem
.el-date-editor
  width: 100% !important
.dialog_img
  text-align center
.dialog_img img
  width 90%
  height 90%
.el-select-dropdown {
  position: absolute !important;
  top: 30px !important;
  left: 0px !important;
}
.text-c
  text-align: center
.top-line
  color: #409EFF
  font-weight: bold
.paste-upload
  border: 1px dashed #000
  height: 50px
  border-radiu: 50%
.mt-label
  line-height: 45px
.el_dialogs >>> .el-dialog__body
    padding-left 0
    padding-right 0
.el_dialogs >>> .el-dialog__header
  padding 0
.messages-list
  min-height: calc(100vh - 210px)
  height: 6rem
  overflow-y: auto
  .messages-con
    padding: .4rem
    .message
      padding: .2rem
    .image_con
      padding: .2rem
  .infinite-item-content
    display: inline-block
    margin-top: .2rem
    padding: 0 .36rem 0 .36rem
    line-height: .9rem
    background-color: #eef0f5
  .popper__arrow
    position: absolute
    top: .04rem
    left: .36rem
    display: block
    margin-right: .06rem
    border-color: transparent
    border-style: solid
    border-width: .18rem
    border-top-width: 0
    border-bottom-color: #eef0f5
    filter: drop-shadow(0 2px 12px rgba(0,0,0,.03))
</style>



// WEBPACK FOOTER //
// src/pages/finance_info/FinanceInfo.vue